import React from "react";
import PropTypes from "prop-types";
import { ListComponent } from "../../../../../common/component/Index";
import {
  columnsTable,
  getDataSource,
  getTitleTable,
} from "../../../../../../../helpers/functions";

const propTypes = {};

const StockAvailableTable = (props) => {
  const { arrProduct = [] } = props;
  
  //! State
  const ListCols = ["supplierProductId", "name", "createAvailable", "stockAvailable"];

  const titleItemTable = getTitleTable(ListCols, [], ["name"]);

  const componentTable = {
    supplierProductId: {
      key: "supplierProductId",
      align: "left",
      width: 250,
      render: (text, record) => record.name
    },
    createAvailable: {
      key: "createAvailable",
      align: "right",
      width: 250,
      render: (text, record) => record.createAvailable || 1
    },
    stockAvailable: {
      key: "stockAvailable",
      align: "right",
      render: (text, record) => {
        return <>{record.stockAvailable ?? undefined}</>}
    },
  };
  //! Function

  //! Render
  return (
    <ListComponent
      tableKey="stock-available-list"
      classChildren="p-0"
      classParent="wrapper-content"
      rowKey={(record, k) => (record.id ? record.id : k)}
      loading={{ spinning: false, size: "large" }}
      dataSource={getDataSource(arrProduct || [], ListCols)}
      columns={columnsTable({
        titleTable: titleItemTable,
        component: componentTable,
        itemName: "ratecode.stockAvailables",
      })}
    />
  );
};

StockAvailableTable.propTypes = propTypes;
export default StockAvailableTable;
